import React from 'react'
import '../../../assets/custom/css/loader.css'

const Loader = () => {
    
    return (  
        <div className="d-flex justify-content-center align-items-center" style={{ height: '90vh', gap: '12px' }}>
            <div style={{ fontSize: '1.5rem', color: '#1e2a55' }}>
                <strong>Loading</strong>
            </div>
            <div className="loader" style={{ alignSelf: 'center', marginTop: '12px' }}></div>
        </div>
   );
}   
    
export default Loader;
